import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardBody, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

class DonationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          dataField: "Time",
          text: "Date&Time",
        },
        {
          dataField: "Donor_Name",
          text: "Donor Name",
        },
        {
          dataField: "Donor_Email",
          text: "Donor Email",
        },
        {
          dataField: "Amount",
          text: "Amount",
        },
      ],
    };
  }
  render() {
    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">Donation Details</h4>

            <div className="mt-4">
              <BootstrapTable
                keyField="id"
                data={this.props.donations}
                columns={this.state.columns}
                pagination={paginationFactory()}
              />
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

DonationList.propTypes = {

  donations: PropTypes.array,
};

export default DonationList;
